import { render, staticRenderFns } from "./Temporizador.vue?vue&type=template&id=55af333a&scoped=true&"
import script from "./Temporizador.vue?vue&type=script&lang=js&"
export * from "./Temporizador.vue?vue&type=script&lang=js&"
import style0 from "./Temporizador.vue?vue&type=style&index=0&id=55af333a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af333a",
  null
  
)

export default component.exports